var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.relevantClasses},[_vm._v("\n\n    "+_vm._s(_vm.loadingStatus || 'loading...')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }